import React from 'react';
import {
  VaultsPage,
  VaultPage,
  BacktestPage,
  VaultAdminPage,
  VaultPerformancePage,
  VaultStrategyPage,
  VaultInfoPage,
} from '@pages';
import { Container, BacktestTabs } from '@components';
import { Switch, Route, Redirect } from 'react-router-dom';

export const Routes = (): JSX.Element => (
  <Container sx={{ flex: 1 }}>
    <Switch>
      <Route exact path="/">
        {/* redirect homepage */}
        <Redirect to="/vaults" />
      </Route>

      <Route exact path="/vaults">
        <VaultsPage />
      </Route>

      <Route exact path="/vaults/:vaultAddress">
        {/* fallback for deprecated vault path */}
        <Redirect to="/vaults" />
      </Route>

      <Route exact path="/vaults/:vaultType/:vaultAddress">
        <VaultPage />
      </Route>

      <Route exact path="/vaults/:vaultType/:vaultAddress/info">
        <VaultInfoPage />
      </Route>

      <Route exact path="/vaults/:vaultType/:vaultAddress/performance">
        <VaultPerformancePage />
      </Route>

      <Route exact path="/vaults/:vaultType/:vaultAddress/admin">
        <VaultAdminPage />
      </Route>

      <Route
        exact
        path="/vaults/:vaultType/:vaultAddress/strategies/:strategyAddress"
      >
        <VaultStrategyPage />
      </Route>

      <Route exact path="/backtest">
        {/* fallback to nav */}
        <BacktestTabs />
      </Route>

      <Route exact path="/backtest/:position?">
        <BacktestPage />
      </Route>
    </Switch>
  </Container>
);
